var parsePageFilter = function parsePageFilter(page) {
  var pageNumber = Number(page);
  if (Number.isNaN(pageNumber)) return 1;
  return Math.max(pageNumber, 1);
};
export default parsePageFilter;